var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('encuestas-contenedor'),_vm._v(" "),_c('semana-exhibiciones',{attrs:{"user-id":_vm.userId}}),_vm._v(" "),_c('tabs-faltantes'),_vm._v(" "),_c('reporte-eficiencia'),_vm._v(" "),_c('br'),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }